import * as React from 'react';
import styled from 'styled-components';
import {getImageByPreview} from 'api/library';
import LessonBuilderContext
  from 'components/LessonBuilder/LessonBuilderContext';
import CardContext from '../../CardContext';
import FileContainer from '../components/FileContainer';
import {GalleryTemplateProps} from '.';
import {ID} from 'types';

export interface ColumnProps {
  value: GalleryTemplateProps['value'];
  id: ID | undefined;
  index: number;
}

const Image = styled.img`
  width: 100%;
  height: 140px;
  border-radius: 5px;
  object-fit: cover;
`;

/**
 * This column renders the file.
 * @param {ColumnProps} props
 * @return {React.ReactElement<ColumnProps>}
 * @constructor
 */
export default function Column(
    props: ColumnProps,
): React.ReactElement<ColumnProps> {
  const cardContext = React.useContext(CardContext);
  const {lesson, setLesson} = React.useContext(LessonBuilderContext);
  const content = lesson?.content || [];
  const value = props.value || [];

  /**
   * Render preview
   * @return {JSX.Element}
   */
  function renderImage(): JSX.Element | undefined {
    /**
     * This delete event handler.
     */
    function handleDelete(): void {
      if (cardContext.index !== undefined) {
        value.splice(props.index, 1);
        content[cardContext.index].value = value;

        (lesson && setLesson) && setLesson({
          ...lesson,
          content,
        });
      }
    }

    return props.id ? (
      <FileContainer
        id={props.id}
        onDelete={handleDelete}
      >
        {(file) => (
          <Image
            src={getImageByPreview({
              id: file.id,
              type: file.type,
              url: file.url,
            })}
            alt={file.title}
          />
        )}
      </FileContainer>
    ) : undefined;
  }

  return (
    <React.Fragment>
      {renderImage()}
    </React.Fragment>
  );
}
